module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', {
    class: _vm.$style.root
  }, [_c('div', [_c('h4', {
    staticClass: "title"
  }, [_vm._v(_vm._s(_vm.title))]), (!_vm.hideChecked) ? _c('icon', {
    staticClass: "status",
    class: ("icon-" + _vm.iconName),
    attrs: {
      "name": _vm.iconName
    }
  }) : _vm._e()], 1), _c('div', {
    staticClass: "description"
  }, [_vm._t("description")], 2), _c('div', {
    staticClass: "content"
  }, [(_vm.icon) ? _c('div', {
    staticClass: "main-icon"
  }, [_c('icon', {
    attrs: {
      "name": _vm.icon,
      "scale": "3"
    }
  })], 1) : _vm._e(), _c('div', [_vm._t("icon")], 2), (_vm.edit) ? _c('b-button', {
    staticClass: "edit",
    attrs: {
      "variant": "link"
    },
    on: {
      "click": function($event) {
        _vm.$emit("edit")
      }
    }
  }, [_c('icon', {
    attrs: {
      "name": "pencil"
    }
  })], 1) : _vm._e()], 1), _vm._t("additional")], 2)
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-64fe8617"}!./~/vue-loader/lib/template-compiler/preprocessor.js?raw&engine=pug!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/rabbit/fill-status/FillStatus.vue
// module id = 2056
// module chunks = 1